@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
@if (fpaEntity()) {
  <div>
    <div class="headerInfo">
      <span class="headerGroup">
        <label class="headerLabel">Entity ID</label>
        <input readonly class="headerValue" [value]="fpaEntity().entityKey.entityId"/>
      </span>
      <span class="headerGroup">
        <label class="headerLabel">Project Name</label>
        <input readonly class="headerValue" [value]="fpaEntity().projectName"/>
      </span>
      <span class="headerGroup">
        <label class="headerLabel">Total List</label>
        <input readonly class="headerValue" [value]="fpaEntity().totalList | currency:'USD'"/>
      </span>
      <span class="headerGroup">
        <label class="headerLabel"># of Units</label>
        <input readonly class="headerValue" [value]="fpaEntity().numberOfUnits"/>
      </span>
      <span class="headerGroup">
        <label class="headerLabel">Rep</label>
        <input readonly class="headerValue" [value]="fpaEntity().salesRep"/>
      </span>
      <span class="headerGroup">
        <label class="headerLabel">Published Multiplier</label>
        <input readonly class="headerValue" [value]="fpaEntity().publishedMultiplier | number:'1.4'"/>
      </span>
      <span class="headerGroup">
        <label class="headerLabel">Final Multiplier</label>
        <input readonly class="headerValue" [value]="fpaEntity().finalMultiplier | number:'1.4'"/>
      </span>
      <span class="headerGroup">
        <label class="headerLabel">Customer</label>
        <input readonly class="headerValue" [value]="fpaEntity().customer"/>
      </span>
      <span class="headerGroup">
        <label class="headerLabel">S &amp; H</label>
        <input readonly class="headerValue" [value]="fpaEntity().shippingCharge | currency:'USD'"/>
      </span>
      <span class="headerGroup">
        <label class="headerLabel">Selected Scenario</label>
        <input readonly class="headerValue" [value]="fpaEntity().selectedScenarioId"/>
      </span>
      <span class="headerGroup">
        <label class="headerLabel">Lead Time</label>
        <input readonly class="headerValue" [value]="fpaEntity().leadTime"/>
      </span>
      <span class="headerGroup">
        <label class="headerLabel">Commission Percent</label>
        <input readonly class="headerValue" [value]="fpaEntity().commissionPercent | percent:'1.2'"/>
      </span>
      <span class="headerGroup">
        <label class="headerLabel">Commission Amount</label>
        <input readonly class="headerValue" [value]="fpaEntity().commissionAmount | currency:'USD'"/>
      </span>
    </div>
    <div class="standardScenariosSection">
      <div class="toolbar">
        <span class="spacer"></span>
        <span>
          <h3 class="toolbarLabel">Standard Scenarios (For Reference Only)</h3>
        </span>
        <span class="spacer"></span>
      </div>
      <table class="reportTable scenarioTable">
        <thead>
          <tr>
            <td class="tableCell headerCell centeredCell">Sale Type</td>
            <td class="tableCell headerCell centeredCell">Multiplier</td>
            <td class="tableCell headerCell centeredCell">Equipment</td>
            <td class="tableCell headerCell centeredCell">S&amp;H Amt</td>
            <td class="tableCell headerCell centeredCell">PO Amt</td>
            <td class="tableCell headerCell centeredCell">Projected Comm. Rate</td>
            <td class="tableCell headerCell centeredCell">Projected Comm. Amt</td>
          </tr>
        </thead>
        @for (scenario of standardBuyResellScenarios(); track scenario) {
          <tr class="selectableRow"
            [class.selectedRow]="selectedStandardScenario() && selectedStandardScenario().saleType == scenario.saleType && selectedStandardScenario().multiplier === scenario.multiplier"
            (click)="selectStandardScenario(scenario)">
            <td class="tableCell">{{ scenario.saleType }}</td>
            <td class="tableCell rightAligned">{{ scenario.multiplier | number:'1.4' }}</td>
            <td class="tableCell rightAligned">{{ getNetAmount(scenario) | currency:'USD' }}</td>
            <td class="tableCell rightAligned">{{ scenario.shippingCharge | currency:'USD' }}</td>
            <td class="tableCell rightAligned">{{ getPoAmount(scenario) | currency:'USD' }}</td>
            <td class="tableCell rightAligned">{{ scenario.commissionPercent | percent:'1.2' }}</td>
            <td class="tableCell rightAligned">{{ getCommissionAmount(scenario) | currency:'USD' }}</td>
          </tr>
        }
      </table>
    </div>
    <div class="customScenariosSection">
      <div class="toolbar">
        <span class="spacer"></span>
        <span class="spacer">
          <h3 class="toolbarLabel">Custom Scenario</h3>
        </span>
        <span>
          @if (fpaEntity().customScenarios.length === 0) {
            <button matButton="text" [disabled]="isBusy()"
              (click)="addCustomScenario()">
              <span>
                <mat-icon>add</mat-icon>
                <label>Add</label>
              </span>
            </button>
          }
          <button matButton="text" [disabled]="isBusy() || !selectedCustomScenario()" (click)="editCustomScenario()">
            <span>
              <mat-icon>edit</mat-icon>
              <label>Edit</label>
            </span>
          </button>
          <button matButton="text" [disabled]="isBusy() || !selectedCustomScenario()" (click)="deleteCustomScenario()">
            <span>
              <mat-icon>delete</mat-icon>
              <label>Delete</label>
            </span>
          </button>
          @if (fpaAdmin) {
            <button matButton="text" [disabled]="!canOverrideCommission()" (click)="overrideCommission()">
              <span>
                <mat-icon>save</mat-icon>
                <label>Save</label>
              </span>
            </button>
          }
        </span>
      </div>
      <table class="reportTable scenarioTable">
        <thead>
          <tr>
            <td class="tableCell headerCell centeredCell">Sale Type</td>
            <td class="tableCell headerCell centeredCell">Requested Multiplier</td>
            <td class="tableCell headerCell centeredCell">Equipment</td>
            <td class="tableCell headerCell centeredCell">S&amp;H Amt</td>
            <td class="tableCell headerCell centeredCell">Special Charges</td>
            <td class="tableCell headerCell centeredCell">PO Amt</td>
            <td class="tableCell headerCell centeredCell">Calculated Comm. Rate</td>
            <td class="tableCell headerCell centeredCell">Calculated Comm. Amt</td>
            <td class="tableCell headerCell centeredCell">Approval</td>
            <td class="tableCell headerCell centeredCell">Final Comm. Rate</td>
            <td class="tableCell headerCell centeredCell">Final Comm. Amt</td>
          </tr>
        </thead>
        @if (fpaEntity().customScenarios.length > 0) {
          @for (scenario of fpaEntity().customScenarios; track scenario) {
            <tr
              [class.selectedRow]="selectedCustomScenario() && selectedCustomScenario().customScenarioId == scenario.customScenarioId"
              class="selectableRow"
              (click)="selectCustomScenario(scenario)">
              <td class="tableCell">{{ scenario.saleType }}</td>
              <td class="tableCell rightAligned">{{ scenario.requestedMultiplier }}</td>
              <td class="tableCell rightAligned">{{ getNetAmount(scenario) | currency:'USD' }}</td>
              <td class="tableCell rightAligned">{{ scenario.shippingCharge | currency:'USD' }}</td>
              <td class="tableCell rightAligned">{{ scenario.specialCharges | currency:'USD' }}</td>
              <td class="tableCell rightAligned">{{ getPoAmount(scenario) | currency:'USD' }}</td>
              <td class="tableCell rightAligned">{{ scenario.commissionPercent | percent:'1.2' }}</td>
              <td class="tableCell rightAligned">{{ getCommissionAmount(scenario) | currency:'USD' }}</td>
              <td class="tableCell">{{ scenario.approvalStatus }}</td>
              <td class="tableCell rightAligned"><input class="commissionInput"
                [readonly]="!fpaAdmin || scenario.saleType != 'C'"
              [(ngModel)]="scenario.overrideCommissionPercent"/></td>
              <td class="tableCell rightAligned">{{ getOverrideCommissionAmount(scenario) | currency:'USD' }}</td>
            </tr>
          }
        }
        @if (fpaEntity().customScenarios.length === 0) {
          <tr>
            <td colspan="11" class="tableCell">No custom scenarios found</td>
          </tr>
        }
      </table>
    </div>
    <div class="toolbar">
      <span>
        <button matButton="text" [disabled]="isBusy()" (click)="backToEntity()">
          <span>
            <mat-icon>keyboard_arrow_left</mat-icon>
            <label>Back</label>
          </span>
        </button>
        <button matButton="text" [disabled]="isBusy() || (!canSubmit())" (click)="submitForApproval()">
          <span>
            <mat-icon>mail_outline</mat-icon>
            <label>Submit for Approval</label>
          </span>
        </button>
        <button matButton="text"
          [disabled]="isBusy() || (!selectedStandardScenario() && (!selectedCustomScenario() || selectedCustomScenario().approvalStatus != 'Approved'))"
          (click)="applySelection()">
          <span>
            <mat-icon>done</mat-icon>
            <label>Apply Selection</label>
          </span>
        </button>
      </span>
    </div>
  </div>
}

